import { Grid } from "@material-ui/core";
import React from "react";

import RemoteMaintenanceCard from "./RemoteMaintenanceCard";

/**
 * RemoteMaintenancePageコンポーネント.
 *
 * @return {object} コンポーネント
 */
function RemoteMaintenancePage() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <RemoteMaintenanceCard />
      </Grid>
    </Grid>
  );
}

export default RemoteMaintenancePage;
